const selectServiceType = {
  serviceType: 'Servicio:',
  department: 'Departamento:',
  brand: 'Marca:',
  description: 'Descripción:',
  place: 'Lugar:',
  reference: 'Punto de referencia:',
  serviceTypeTitle: 'Tipo de servicio',
  onTime: 'A tiempo',
  overdue: 'Atrasado',
  noService: 'Sin servicio',
  mandatory: 'Servicio obligatorio',
  expiration: 'Fecha de caducidad:',
  daysRemaining: 'días restantes',
  daysOverdue: 'días de atraso',
  dayRemaining: 'día restantes',
  dayOverdue: 'día de atraso',
  buttonGoBack: 'volver',
  lastPerform: 'Última inspección:',
  onDemand: 'Servicio bajo demanda',
};

export default selectServiceType;